const headers = {
  name: "Brokers",
  navigate: {
    path: [
      {
        name: "Brokers",
        path: "/app/contacts/brokers",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
